import React from 'react';
import { ImageCarousel } from '../components/ImageCarousel';
import { PricingCard } from '../components/PricingCard';
import { ProductList } from '../components/ProductList';
import { CheckCircle2, Download, Edit, DollarSign, Star, ArrowRight, ShieldCheck, Zap } from 'lucide-react';
const IMAGES = ['https://cdn.magicpatterns.com/uploads/3H2xaJGnjUJ4Rd2hhaetmM/1.jpg', 'https://cdn.magicpatterns.com/uploads/eyEHk6K5SsoEKEH9fXBg7Z/2.jpg', 'https://cdn.magicpatterns.com/uploads/uRZ8HzHwUDgvrBXyxyqPJK/4.jpg', 'https://cdn.magicpatterns.com/uploads/xn13w5mL1VcEtoBAoEfrbF/5.jpg', 'https://cdn.magicpatterns.com/uploads/veuLvHR9VNHMpkgXaraQTK/6.jpg'];
const ANNOUNCEMENT_MESSAGES = ['🎉 SPECIAL OFFER: GET 80% OFF TODAY ONLY!', '🔥 HUGE PLR BUNDLES', '⚡ FLASH SALE', '✨ DONE FOR YOU PLR'];
export function PlannerBundlePage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-59">
      {/* Animated Announcement Bar */}
      <div className="bg-gradient-to-r from-pink-600 to-purple-600 text-white overflow-hidden relative" data-id="element-60">
        <div className="flex animate-scroll whitespace-nowrap" data-id="element-61">
          {/* Duplicate messages for seamless loop */}
          {[...ANNOUNCEMENT_MESSAGES, ...ANNOUNCEMENT_MESSAGES].map((message, index) => <span key={index} className="inline-block py-2 px-8 text-sm font-bold tracking-wide" data-id="element-62">
                {message}
              </span>)}
        </div>
      </div>

      {/* Hero Section */}
      <header className="relative overflow-hidden bg-gradient-to-b from-purple-50 to-white pt-8 pb-12 px-4 sm:px-6 lg:px-8" data-id="element-63">
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-30 pointer-events-none" data-id="element-64">
          <div className="absolute top-10 left-10 w-64 h-64 bg-pink-300 rounded-full mix-blend-multiply filter blur-3xl animate-blob" data-id="element-65"></div>
          <div className="absolute top-10 right-10 w-64 h-64 bg-purple-300 rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-2000" data-id="element-66"></div>
          <div className="absolute -bottom-8 left-20 w-64 h-64 bg-yellow-200 rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-4000" data-id="element-67"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto text-center" data-id="element-68">
          <div className="inline-block mb-4 px-4 py-1.5 rounded-full bg-blue-100 text-blue-700 font-bold text-sm tracking-wide uppercase" data-id="element-69">
            New 2026 Collection
          </div>

          <h1 className="text-4xl md:text-7xl font-extrabold tracking-tight text-gray-900 mb-3" data-id="element-70">
            Start Your Digital Business <br data-id="element-71" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-500 via-purple-500 to-blue-500" data-id="element-72">
              In Minutes, Not Months
            </span>
          </h1>

          <p className="mt-3 max-w-2xl mx-auto text-lg md:text-xl text-gray-600 mb-8" data-id="element-73">
            Get 15,000+ editable planners, journals, and trackers plus 8,000
            bonus stickers.
            <span className="font-bold text-gray-900" data-id="element-74">
              {' '}
              100% Resell Rights Included.
            </span>
          </p>

          {/* Carousel */}
          <div id="preview" className="mb-8" data-id="element-75">
            <ImageCarousel images={IMAGES} data-id="element-76" />
          </div>

          {/* CTA Button moved below carousel */}
          <div className="flex justify-center mb-8" data-id="element-77">
            <a href="#pricing" className="px-8 py-4 bg-gradient-to-r from-pink-500 via-purple-500 to-blue-500 text-white rounded-full font-bold text-lg hover:shadow-xl transition-all hover:scale-105 shadow-lg flex items-center justify-center gap-2" data-id="element-78">
              Get The Bundle <ArrowRight className="w-5 h-5" data-id="element-79" />
            </a>
          </div>

          {/* Social Proof / Trust Bar */}
          <div className="flex flex-wrap justify-center gap-6 md:gap-16 text-gray-400 font-medium uppercase tracking-widest text-xs md:text-sm" data-id="element-80">
            <span className="flex items-center gap-2" data-id="element-81">
              <Star className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-82" />{' '}
              5-Star Rated
            </span>
            <span className="flex items-center gap-2" data-id="element-83">
              <Download className="w-4 h-4" data-id="element-84" /> Instant Access
            </span>
            <span className="flex items-center gap-2" data-id="element-85">
              <ShieldCheck className="w-4 h-4" data-id="element-86" /> Secure Payment
            </span>
          </div>
        </div>
      </header>

      {/* Benefits Section */}
      <section className="py-12 md:py-20 bg-gradient-to-b from-purple-50 via-pink-50 to-blue-50" data-id="element-87">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-88">
          <div className="text-center mb-10 md:mb-16" data-id="element-89">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2" data-id="element-90">
              Why This Bundle Is Perfect For You
            </h2>
            <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-91">
              Stop wasting time designing from scratch. We've done the hard work
              so you can focus on selling.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8" data-id="element-92">
            {[{
            icon: <Edit className="w-8 h-8 text-pink-500" data-id="element-93" />,
            title: '100% Editable',
            desc: 'Fully customizable in Canva. Change colors, fonts, and layouts to match your brand.'
          }, {
            icon: <DollarSign className="w-8 h-8 text-green-500" data-id="element-94" />,
            title: 'Resell Rights',
            desc: 'Sell these products as your own and keep 100% of the profits. No royalties ever.'
          }, {
            icon: <Zap className="w-8 h-8 text-yellow-500" data-id="element-95" />,
            title: 'Save Time',
            desc: 'Skip hundreds of hours of design work. Launch your shop in a single afternoon.'
          }, {
            icon: <Star className="w-8 h-8 text-purple-500" data-id="element-96" />,
            title: 'High Quality',
            desc: 'Professionally designed templates that look amazing and sell like hotcakes.'
          }].map((benefit, i) => <div key={i} className="bg-white rounded-2xl p-6 md:p-8 hover:shadow-xl transition-all border border-gray-100 group" data-id="element-97">
                <div className="bg-gradient-to-br from-purple-50 to-pink-50 w-16 h-16 rounded-2xl flex items-center justify-center shadow-sm mb-4 group-hover:scale-110 transition-transform" data-id="element-98">
                  {benefit.icon}
                </div>
                <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2" data-id="element-99">
                  {benefit.title}
                </h3>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed" data-id="element-100">
                  {benefit.desc}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Product List Section */}
      <section className="py-12 md:py-20 bg-gradient-to-b from-blue-50 via-purple-50 to-pink-50" data-id="element-101">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-102">
          <div className="text-center mb-10 md:mb-16" data-id="element-103">
            <span className="text-purple-600 font-bold tracking-wider uppercase text-sm" data-id="element-104">
              What's Inside
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mt-2 mb-3" data-id="element-105">
              15,000+ Pages of Content
            </h2>
            <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-106">
              From personal development to business planning, we've covered
              every profitable niche.
            </p>
          </div>

          <ProductList data-id="element-107" />

          <div className="mt-12 md:mt-16 text-center" data-id="element-108">
            <a href="#pricing" className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-full text-white bg-gradient-to-r from-pink-500 via-purple-500 to-blue-500 hover:shadow-xl transition-all hover:scale-105" data-id="element-109">
              Unlock Full Access Now
            </a>
          </div>
        </div>
      </section>

      {/* Bonus Section */}
      <section className="py-12 md:py-20 bg-gradient-to-br from-pink-600 via-purple-600 to-blue-600 text-white overflow-hidden relative" data-id="element-110">
        {/* Background decoration */}
        <div className="absolute top-0 right-0 -mr-20 -mt-20 w-96 h-96 bg-yellow-400 rounded-full mix-blend-overlay filter blur-3xl opacity-20" data-id="element-111"></div>
        <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-96 h-96 bg-pink-400 rounded-full mix-blend-overlay filter blur-3xl opacity-20" data-id="element-112"></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-113">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-114">
            <div data-id="element-115">
              <div className="inline-block bg-yellow-400 text-black font-bold px-4 py-1 rounded-full mb-4" data-id="element-116">
                EXCLUSIVE BONUS
              </div>
              <h2 className="text-3xl md:text-5xl font-bold mb-3 md:mb-6" data-id="element-117">
                8,000+ Digital Stickers Included Free!
              </h2>
              <p className="text-lg md:text-xl text-gray-100 mb-6 md:mb-8 leading-relaxed" data-id="element-118">
                Make your planners pop with our massive library of pre-cropped
                digital stickers. Perfect for GoodNotes, Notability, and other
                digital planning apps.
              </p>

              <ul className="space-y-3 md:space-y-4 mb-8 md:mb-10" data-id="element-119">
                {['Functional planning stickers', 'Decorative washi tapes', 'Motivational quotes', 'Seasonal & holiday themes', 'Finance & budget icons', 'Fitness & health trackers'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-120">
                    <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-yellow-300 flex-shrink-0" data-id="element-121" />
                    <span className="text-base md:text-lg" data-id="element-122">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="relative" data-id="element-123">
              <div className="absolute inset-0 bg-gradient-to-r from-yellow-400 to-pink-400 rounded-3xl transform rotate-3 opacity-30 blur-lg" data-id="element-124"></div>
              <img src="https://cdn.magicpatterns.com/uploads/uRZ8HzHwUDgvrBXyxyqPJK/4.jpg" alt="Digital Stickers Preview" className="relative rounded-3xl shadow-2xl border-4 border-white/20 transform hover:scale-[1.02] transition-transform duration-500" data-id="element-125" />
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section - Reduced top padding */}
      <section id="pricing" className="pt-8 md:pt-12 pb-16 md:pb-24 bg-gradient-to-b from-purple-50 via-pink-50 to-blue-50 relative" data-id="element-126">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-127">
          <div className="text-center mb-8 md:mb-12" data-id="element-128">
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-2 md:mb-4" data-id="element-129">
              Start Your Empire Today
            </h2>
            <p className="text-lg md:text-xl text-gray-600" data-id="element-130">
              One small investment. Unlimited profit potential.
            </p>
          </div>

          <PricingCard data-id="element-131" />

          <div className="mt-8 md:mt-12 max-w-2xl mx-auto text-center" data-id="element-132">
            <p className="text-xs md:text-sm text-gray-500" data-id="element-133">
              * This is a digital download. No physical product will be shipped.
              Due to the nature of digital products, all sales are final.
            </p>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-12 md:py-20 bg-gradient-to-r from-pink-500 via-purple-500 to-blue-500 text-white" data-id="element-134">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-135">
          <h2 className="text-2xl md:text-3xl font-bold mb-3 md:mb-6" data-id="element-136">
            Don't Miss Out on This Opportunity
          </h2>
          <p className="text-base md:text-lg mb-6 md:mb-8 text-gray-100" data-id="element-137">
            Join thousands of other digital entrepreneurs who are building their
            dream business with our templates.
          </p>
          <a href="#pricing" className="inline-block px-10 md:px-12 py-4 md:py-5 bg-white text-purple-600 text-lg md:text-xl font-bold rounded-full hover:bg-gray-100 hover:scale-105 transition-all shadow-xl" data-id="element-138">
            Grab The Bundle Now
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gradient-to-r from-purple-100 to-pink-100 py-8 md:py-12 border-t border-purple-200" data-id="element-139">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-4 md:gap-6" data-id="element-140">
          <div className="text-gray-900 font-bold text-lg md:text-xl" data-id="element-141">
            PLR Mega Bundle
          </div>
          <div className="text-gray-600 text-xs md:text-sm" data-id="element-142">
            © {new Date().getFullYear()} All rights reserved.
          </div>
          <div className="flex gap-4 md:gap-6 text-xs md:text-sm text-gray-600" data-id="element-143">
            <a href="#" className="hover:text-gray-900" data-id="element-144">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-gray-900" data-id="element-145">
              Terms of Service
            </a>
            <a href="#" className="hover:text-gray-900" data-id="element-146">
              Support
            </a>
          </div>
        </div>
      </footer>
    </div>;
}